import { baseApi } from "./apiConfig";

export const fetchUpcomingAuctionsApi = async()=>{
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.get(`portal/watchListing/0?buyerInterestedInCom=Y&_=${timestamp}`);
        return response.data;
    } catch (error) {
        console.log("Error in feteching upcoming auctions api",error);
        throw error;
    }
}